export default "__VITE_ASSET__CyNODhbX__"